module.exports = __webpack_public_path__ + "img/ca.d3196a83.svg";